<template>
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
    class="recall-form"
  >
    <v-container>
      <h2 class="title">Add Recall for {{$route.params.saleId}}</h2>
      <ReceiptDetails
        :form="recall"
        :itemOptions="itemOptions"
      />
      <PaymentDetails
        :form="recall"
        :options="paymentOptions"
      />
      <v-btn
        color="success"
        class="mr-4"
        @click="submit"
      >
        Save
      </v-btn>
      <v-btn
        color="error"
        class="mr-4"
        @click="reset"
      >
        Reset
      </v-btn>
    </v-container>

  </v-form>
</template>

<script>
import ReceiptDetails from "./ReceiptDetails.vue";
import PaymentDetails from "./PaymentDetails.vue";

const defaultItem = { type: '', description: '', value: '' };

export default {
  name: "RecallForm",
  components: {
    ReceiptDetails,
    PaymentDetails
  },
  data: (vm) => ({
    valid: false,
    recall: {
      date: new Date().toISOString().substr(0, 10),
      notes: '',
			items: [
				{...defaultItem}
			],
			payments: [
				{...defaultItem}
			],
    },
    itemOptions: [
      { value:"travelfee", text: "Travel Fee (in $)" },
      { value:"ccfee", text: "CC Fee (in $)" },
    ],
    paymentOptions: [
      { value: "cc", text: "Credit Card" },
      { value: "cash", text: "Cash" },
      { value: "check", text: "Check" },
      { value: "zelle", text: "Zelle" },
    ],
    updating: false
  }),
  methods: {
    submit() {
      this.updating = true;
      if (this.$refs.form.validate()) {
        if(this.$route.params.id) {
          this.update(this.$route.params.id);
        } else {
          this.save();
        }
      }
      this.updating = false;
    },
    getTotal() {
      let total = 0;
      this.recall.items.forEach((item) => {
        if(item.value) total += parseFloat(item.value);
      });
      return parseFloat(total.toFixed(2));
    },
    async save () {
      try {
        await this.$recallService.addRecall({
          saleId: this.$route.params.saleId,
          total: this.getTotal(),
          ...this.recall,
        });
        this.reset();
        this.$successResponse(null, 'toast', 'Recall added successfully!');
        this.$router.push("/sales")
      } catch (error) {
        this.$errorResponse(error);
      }
    },
    async update(recallId) {
      try {
        await this.$recallService.updateRecall(recallId, {
          saleId: this.$route.params.saleId,
          total: this.getTotal(),
          ...this.recall,
        });
        
        this.reset();
        this.$successResponse(null, 'toast', 'Recall updated successfully!');
        this.$router.push("/sales")
      } catch (error) {
        this.$errorResponse(error);
      }
    },
    async getRecall(recallId) {
      try {
        await this.$recallService.getRecall(recallId);
      } catch (error) {
        this.$errorResponse(error);
      }
    },
    reset () {
      this.$refs.form.reset();
    }
  },
  mounted() {
    if(this.$route.params && this.$route.params.id) {
      this.getRecall(this.$route.params.id);
    }
  }
};
</script>